export const commentsPreset = [
  'The document does not contain information about the payment system.',
  'The expiration date of the card must be visible in the photo.',
  'The first 6 and last 4 digits of the card number must be visible.',
  'A scanned document cannot be accepted. Please upload a photo of the document.',
  'All corners of the document must be visible in the photo.',
  'The document is not readable, please upload the document in good quality.',
  'Cropped screenshot/image cannot be accepted.',
  'Please upload your selfie with your passport/ ID card / driver’s license in your hands.',
  'Please upload a color photo of the CC ** (front / back side).',
  'Please upload a color photo of the bank card (front / back side).',
  'Please upload an account statement  ** (not older than 3 months).',
  'Please upload a screenshot of your bank profile with your: IBAN; BIC; Address. There can be several screenshots.',
  'Please upload a screenshot of the virtual card СС**.',
]
export const internalPreset = [
  'Bank statement',
  'Bank screen (IBAN/BIC/Address)',
  'Bank card (front/back side).(IBAN/BIC)',
  'Confirmation doc.',
  'Screenshot Wallet',
  'Utility bill.',
  'ID card / Passport / Driver’s license (front / back side)',
  'CC **____ (front / back side).'
]
